// Offline copies and replay records hold site data, never secrets or account
// administration. Keep this boundary shared by the browser and Worker caches.
// Bearer authorization is separate: a script may manage a webhook, for example,
// but its signing secret must never enter either offline cache.
// The stock places (ROADMAP J2) are the account's own list of warehouses and
// vans, not a site's data: they are managed from a settings page rather than
// on the way round a property, and the Stock page reads every client's
// devices at once, which no offline copy of one property holds. Moving one
// device into or out of stock is an ordinary write on that device and is not
// listed here.
const ONLINE_ONLY_ROUTES = [
  /^\/api\/(?:auth|users|webhooks|shares|audit|export|import|geocode|map|search|resources|credentials|vault|service-requests|stock-places)(?:\/|$)/u,
  /^\/api\/(?:clients|properties|items)\/[^/]+\/(?:credentials|access|vault|shares|service-requests|reports?|pdf|csv)(?:[/.]|$)/u,
  // Downloads are documents, never reads a page opens again without a signal.
  /^\/api\/.*\.(?:csv|xlsx|docx|pdf)$/u,
];

/** Whether this request needs the server and must never be kept for replay. */
export function isOnlineOnlyRoute(path: string): boolean {
  const [pathname = ''] = path.split(/[?#]/u);
  return !pathname.startsWith('/api/') || ONLINE_ONLY_ROUTES.some((route) => route.test(pathname));
}
